import { render, staticRenderFns } from "./AppMoreinfo.vue?vue&type=template&id=5d54cbe2&scoped=true&"
import script from "./AppMoreinfo.vue?vue&type=script&lang=js&"
export * from "./AppMoreinfo.vue?vue&type=script&lang=js&"
import style0 from "./AppMoreinfo.vue?vue&type=style&index=0&id=5d54cbe2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d54cbe2",
  null
  
)

component.options.__file = "AppMoreinfo.vue"
export default component.exports